module.exports = ".template-input {\n  width: 100%;\n  margin-top: 10px; }\n"